const promocodes =  [
    {
        path: '/promocodes',
        name: 'promocodes.index',
        component: () => import('@/pages/Promocode/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: false,
            layout: 'content',
            title: "Promokodlarlar",
        }
    },
    {
        path: '/promocodes/create',
        name: 'promocodes.create',
        component: () => import('@/pages/Promocode/CreatePage.vue'),
        meta: {
            need_project: false,
            requiresAuth: true,
            layout: 'content',
            title: "Promokodlar yaratish",
        }
    },
    {
        path: '/promocodes/:id/show',
        name: 'promocodes.show',
        component: () => import('@/pages/Promocode/EditPage.vue'),
        meta: {
            need_project: false,
            requiresAuth: true,
            layout: 'content',
            title: "Promokodlar yaratish",
        }
    },
]

export default promocodes